import { render, staticRenderFns } from "./firstPage1.vue?vue&type=template&id=27e71f25&scoped=true&"
import script from "./firstPage1.vue?vue&type=script&lang=js&"
export * from "./firstPage1.vue?vue&type=script&lang=js&"
import style0 from "./firstPage1.vue?vue&type=style&index=0&id=27e71f25&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e71f25",
  null
  
)

export default component.exports